@if (this.userStore.isSuspended()) {
  <bn-web-ui-not-available
    [options]="{
      title: 'Your account was suspended.',
      description:
        'Your account has been flagged by our automatic fraud prevention system. If you believe this is a mistake, please contact us at <strong>support@bunny.net</strong>.',
      height: '250px',
      buttonsOptions: [
        {
          clickAction: 'primary',
          text: 'Contact support',
          routerLink: '/support/tickets/new',
          queryParams: {
            Department: SupportDepartmentType.Account,
            Issue: 2,
          },
          leftIcon: 'envelope-open',
        },
        {
          clickAction: 'secondary',
          text: 'Abuse cases',
          routerLink: '/account/dmca',
          itemStyle: 'stroke',
        },
      ],
      imageOptions: {
        isAbsolute: true,
        bottom: '0px',
        maxHeight: '200px',
        top: '25px',
        left: '50px',
        fileName: 'bunny-account-suspended.svg',
      },
    }" />
}
